import Vue from 'vue'
import Router from 'vue-router'
// import store from 'store'
// import {getCookie} from '../common/common'
import { getSessionStore } from '@/common/common'
import headerNav from '@/common/nav/headerNav'
import leftNav from '@/common/nav/leftNav'
import home from '@/components/home'
import login from '@/components/login'
import notFound from '@/components/notFound'
import systemSetup from '@/components/systemSetup'
import details from '@/components/details'


Vue.use(Router)

let router = new Router({
  routes: [
  // {
  //   path: '/',
  //   redirect: '/home'
  // }, 
  {
    path: '/',
    component: login
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    meta: {
      keepAlive: true
    }
  }, {
    path: '/headerNav',
    name: 'headerNav',
    component: headerNav,
    meta: {
      keepAlive: true
    }
  }, {
    path: '/leftNav',
    name: 'leftNav',
    component: leftNav,
    meta: {
      keepAlive: true
    }
  }, {
    path: '/systemSetup',
    name: 'systemSetup',
    component: systemSetup,
    meta: {
      keepAlive: true
    }
  }, {
    path: '/notFound',
    name: 'notFound',
    component: notFound,
    meta: {
      keepAlive: true
    }
  }, {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      keepAlive: false
    }
  },{
    path: '/details',
    name: 'details',
    component: details,
    meta: {
      keepAlive: false
    }
    
  }]
})

router.beforeEach((to, from, next) => {
  console.log(to, from, next)
  if (to.path === '/login') {
    next()
  } else {
    setTimeout(() => {
      if (getSessionStore('SignIn')) {
        if (getSessionStore('SignIn') != 'ok') {
          next({
            path: 'login'
          })
        } else {
          next()
        }
      } else {
        next({
          path: 'login'
        })
      }
    }, 500)
  }
})

// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next()
//   } else {
//     if (getCookie('JSESSIONID')) {
//       // 添加路由拦截器未登录用户跳转到登录页
//       if (JSON.stringify(store.getters['user/userInfo']) === '{}') {
//         store.dispatch('user/getUserInfo').then(() => {
//           next()
//         }).catch(err => {
//           next({
//             path: 'login'
//           })
//         })
//       } else {
//         next()
//       }
//     } else {
//       next({
//         path: 'login'
//       })
//     }
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js